/* global jQuery */
void (function initGallery($) {
	'use strict';
	$(document).ready(() => {
		const timeOut = 225;

		$('.gallery--filter .filter--item').on('click', (event) => {
			const tabCategory = $(event.target).attr('category');

			$('.gallery--filter .filter--item').removeClass(
				'filter--item__active'
			);
			$(event.target).addClass('filter--item__active');

			$('.gallery--item').each((index, element) => {
				const targetElement = $(event.target)
					.parents('.gallery')
					.find($(element));

				const contentCategories = $(element)
					.attr('category')
					.split('_');

				if (contentCategories.indexOf(tabCategory) > -1) {
					if (tabCategory === 'All') {
						$('.gallery--item').show();
						$('.gallery--item').addClass('gallery--item__active');
					} else {
						$(targetElement).show();
						$(targetElement).addClass('gallery--item__active');
					}
				} else if (tabCategory === 'All') {
					$(targetElement).show();
					$(targetElement).addClass('gallery--item__active');
				} else {
					$(targetElement).removeClass('gallery--item__active');
					setTimeout(() => {
						$(targetElement).hide();
					}, timeOut);
				}
			});
		});

		$('.gallery--item').on('click', (event) => {
			const targetModuleTitle = $(event.target)
				.parents('.gallery')
				.attr('id');
			const targetLightbox = $(event.target)
				.parents('.gallery')
				.find('.lightbox-link');

			$(targetLightbox).attr('data-lightbox', targetModuleTitle);
		});
	});
})(jQuery);
